module.exports = __webpack_public_path__ + "static/Group 6761-949c9c991b2ccff474ba0452f3f55a52.png";